<script lang="ts" setup>
import type { LogicWrapperCollection } from '@integration-layer/ampliance/schemas/logic-wrapper-collection-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: LogicWrapperCollection
}>()

const data = await useComponentResponse<LogicWrapperCollection>(props)
const { user } = useUserSession()
const { isLogged } = useLogin()

const components = computed(() =>
  connectComponents(
    // @ts-ignore
    data.value?.listOfLogicWrapper ?? [],
    props.locale,
    props.vse
  )
)

const eligibleTags = computed<string[]>(() => {
  const raw = data.value?.userTags
  if (!raw) return []
  return raw
    .split('|')
    .map(t => t.trim())
    .filter(Boolean)
})

const clCustomerId = computed(
  () => user.value?.user_metadata?.commercelayer_id as string | undefined
)
const customerTags = ref<string[] | null>(null)

watch(
  [eligibleTags, () => isLogged, clCustomerId],
  async ([tags, logged, clId]) => {
    if (!tags?.length) {
      customerTags.value = null
      return
    }
    // Se non loggato o manca id CL, gating fallisce
    if (!logged || !clId) {
      customerTags.value = []
      return
    }
    try {
      customerTags.value = user?.value?.user_metadata?.customer_tags || []
      if (customerTags.value?.length === 0) {
        const id = user?.value?.user_metadata?.commercelayer_id as string
        customerTags.value = await getCustomerTags(id)
      }
    } catch (e) {
      console.error('Errore fetch customer tags:', e)
      customerTags.value = []
    }
  },
  { immediate: true }
)

const passesUserTags = computed<boolean>(() => {
  if (!eligibleTags.value.length) return true
  if (!customerTags.value) return false
  return eligibleTags.value.some(tag => customerTags.value?.includes(tag))
})

const showComponent = computed(() => {
  return Boolean(passesUserTags.value)
})
</script>

<template>
  <div>
    <AmplienceDynamicContent
      v-if="data && showComponent"
      :components
      first-page-content
    />
  </div>
</template>
